interface ButtonAndLinkClicksTrackingData {
  event_action: string;
  event_label: string;
  event_category?: string;
  link_name?: string
}

interface CustomWindow extends Window {
  onButtonAndLinkClicksEvent?: (
    trackingData: ButtonAndLinkClicksTrackingData
  ) => void;
}

const fireButtonAndLinkClicksEvent = (
  trackingData: ButtonAndLinkClicksTrackingData
) => {
  try {
    // fire the utag link event
    if ((window as CustomWindow).onButtonAndLinkClicksEvent) {
      (window as CustomWindow).onButtonAndLinkClicksEvent!(trackingData);
    }
  } catch (e) {
    console.log(
      'onButtonAndLinkClicksEvent failed - please check the Button and Link Clicks Script'
    );
  }
};

export default fireButtonAndLinkClicksEvent;